export default {"src":"/_next/static/media/angle-down-solid.53e403a8.svg","height":512,"width":384};